<script>
import Layout from '@layouts/main'
import LoginSidebar from '@components/login-sidebar'
import { authMethods } from '@state/helpers'

export default {
  components: { Layout, LoginSidebar },
  metaInfo: {
    title: 'Register',
    meta: [{ name: 'description', content: `Register` }],
  },
  data() {
    return {
      username: '',
      password: '',
      organizationName: '',
      firstName: '',
      lastName: '',
      authError: null,
      tryingToRegister: false,
      valid: false,
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid',
      ],
      passwordRules: [v => !!v || 'Password is required'],
      orgRules: [v => !!v || 'Organization is required'],
      firstRules: [v => !!v || 'First Name is required'],
      lastRules: [v => !!v || 'Last Name is required'],
    }
  },
  computed: {
    placeholders() {
      return {
        organizationName: 'Organization Name',
        username: 'user@email.com',
        password: 'password',
        firstName: 'First Name',
        lastName: 'Last Name',
      }
    },
  },
  methods: {
    ...authMethods,
    // Try to log the user in with the username
    // and password they provided.
    tryToRegister() {
      if (!this.$refs.form.validate()) {
        return
      }

      this.tryingToRegister = true
      // Reset the authError if it existed.
      this.authError = null
      return this.register({
        organization: {
          name: this.organizationName,
        },
        user: {
          username: this.username,
          password: this.password,
          firstName: this.firstName,
          lastName: this.lastName,
        },
      })
        .then(token => {
          this.tryingToRegister = false

          // Redirect to the originally requested page, or to the home page
          this.$router.push(this.$route.query.redirectFrom || { name: 'home' })
        })
        .catch(error => {
          this.tryingToRegister = false
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.error
          ) {
            this.authError = error.response.data.error
          } else {
            this.authError = 'There was an error registering your account.'
          }
        })
    },
  },
}
</script>

<template>
  <Layout row class="pa-0">
    <LoginSidebar />

    <v-flex xs7 class="main">
      <v-layout fill-height justify-center>
        <v-flex sm7 class="form">
          <h2>Register</h2>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
            @submit.prevent="tryToRegister"
          >
            <v-text-field
              v-model="organizationName"
              name="organizationName"
              label="Organization"
              :rules="orgRules"
              required
            />
            <v-text-field
              v-model="firstName"
              name="firstName"
              label="First Name"
              :rules="firstRules"
              required
            />
            <v-text-field
              v-model="lastName"
              name="lastName"
              label="Last Name"
              :rules="lastRules"
              required
            />
            <v-text-field
              v-model="username"
              name="username"
              :rules="emailRules"
              label="E-mail"
              required
            ></v-text-field>
            <v-text-field
              v-model="password"
              :rules="passwordRules"
              name="password"
              type="password"
              label="Password"
              required
            ></v-text-field>

            <v-btn
              depressed
              block
              primary
              class="btn-blue"
              :disabled="!valid || tryingToRegister"
              type="submit"
            >
              <BaseIcon v-if="tryingToRegister" name="sync" spin />
              <span v-else>Sign Up</span>
            </v-btn>
          </v-form>
          <p v-if="authError">{{ authError }}</p>

          <hr />

          <p>Already have an account?</p>
          <v-btn outline block class="btn-blue-outline" :to="{ name: 'login' }">
            <span>Login</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
  </Layout>
</template>

<style lang="scss">
@import '@design';
</style>
